import { render, staticRenderFns } from "./serveMuneDialog.vue?vue&type=template&id=5969d53a&scoped=true&"
import script from "./serveMuneDialog.vue?vue&type=script&lang=js&"
export * from "./serveMuneDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969d53a",
  null
  
)

export default component.exports